/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'query-string';
import Backdrop from '../../components/backdrop/Backdrop';
import userApi from '../../api/user.api';
import { RoutePath } from '../../shared/enums/RoutePath';
import ErrorPage from '../../shared/error/ErrorPage';
import { EmailInvitationType } from '../../shared/enums/EmailInvitationType';

export const EmailInvitationAccept = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { invitationType, invitationId } = useParams();
  const [isError, setError] = useState(false);

  useEffect(() => {
    try {
      userApi.acceptInvitation(invitationId).then(async (response) => {
        switch (invitationType) {
          case EmailInvitationType.AUTOMATIC_REGISTRATION.value:
            history.replace({
              pathname: RoutePath.generateRoutePath(RoutePath.SWITCH_ACCOUNT, {}),
              search: qs.stringify({
                shouldRefreshToken: true,
              }),
            });
            break;
          case EmailInvitationType.EXTERNAL_SIGN.value:
            if (response.shouldRefreshToken) {
              // reload the window to force another login process to retrieve the new permissions.
              window.location.reload();
            } else {
              history.replace(
                RoutePath.generateRoutePath(RoutePath.PROCEDURE_NON_ORG_PREVIEW_SUBMISSION, {
                  procedure: response?.submissionProcedure,
                  submissionId: response?.submissionId,
                }),
              );
            }
            break;
          default:
            setError(true);
            throw new Error(`Invitation type '${invitationType}' is not handled`);
        }
      });
    } catch (err) {
      setError(true);
    }
  }, [invitationId]);

  if (isError) return <ErrorPage error={t('user-management.invitation.expired')} />;

  return <Backdrop blocking={true} />;
};
